import { connect } from 'react-redux';
import View from './component';
import { isShowPhases } from '../../../../../../selectors';

const mapStateToProps = (state) => ({
  isShow: isShowPhases(state),
});

const mapDispatchToProps = () => ({});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(View);
